import { action, makeObservable, observable } from 'mobx';

import {
  ICallUIFeatures,
  ParticipantGridDisplayMode,
  MemberListDisplayMode,
  ParticipantsControlType,
  PermissionsSectionDisplayMode,
} from '@gem/call/Model/callModel.types';

export class UiFeatures {
  @observable participantsControlType: ParticipantsControlType =
    ParticipantsControlType.WithMaxNumber;
  @observable raiseHandControlEnabled = false;
  @observable endCallForAllEnabled = false;
  @observable permissionsAndAccessControlEnabled = false;
  @observable excludeParticipantsFromUserSearch = false;
  @observable showParticipantsNumberRestrictionBanner = false;
  @observable showControlMic = true;
  @observable showControlCamera = true;
  @observable showControlScreenSharing = false;
  @observable changeParticipantRole = false;
  @observable participantGridDisplayMode: ParticipantGridDisplayMode =
    ParticipantGridDisplayMode.All;
  @observable showCopyLinkInMoreMenu = true;
  @observable showControlBackground = false;
  @observable showControlRecording = false;
  @observable showControlInviteMembers = false;
  @observable isActiveControlParticipantListWeb = false;
  @observable permissionsSectionDisplayMode: PermissionsSectionDisplayMode =
    PermissionsSectionDisplayMode.CustomPermissions;
  @observable memberListDisplayMode: MemberListDisplayMode = MemberListDisplayMode.Default;
  @observable showCallWillEndSoonBanner = false;
  @observable showParticipantsLimitWillReachSoonBanner = false;
  @observable showDurationLimitReachedBanner = false;
  @observable showParticipantsRestrictedLimitReachedBanner = false;
  constructor() {
    makeObservable(this);
  }

  @action
  setUiFeatures(uiFeatures: Partial<ICallUIFeatures>): void {
    Object.keys(uiFeatures).forEach((key: keyof typeof uiFeatures) => {
      if (typeof uiFeatures[key] !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this[key] = uiFeatures[key];
      }
    });
  }
}
